module.exports = __webpack_public_path__ + "static/media/concert-3.a2b75527.png";